import { alpha, useTheme } from '@mui/material'
import { Button } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'

const NumberButton = ({
    number,
    onClick,
}: {
    number: string
    onClick: (v: string) => void
}) => {
    const { palette } = useTheme()
    const {
        isLandscapeMobile,
        isMediumScreen,
        isMobile,
        isLandscapeTablet,
    } = useScreenSize()
    return (
        <Button
            sx={
                {
                    backgroundColor: alpha('#fff', 0.2),
                    boxShadow: 'none',
                    color: '#fff',
                    textTransform: 'none',
                    border: '0px solid',
                    borderRadius: '100%',
                    lineHeight: 1.5,
                    borderColor: '#fff',
                    '&:hover': {
                        backgroundColor: alpha('#fff', 0.2),
                        boxShadow: 'none',
                        color: '#fff',
                    },
                    '&:focus': {
                        backgroundColor: alpha('#fff', 0.2),
                        boxShadow: 'none',
                        transition: 'ease-out 0.3s',
                    },
                    '&:active': {
                        backgroundColor: palette.info.main,
                        borderColor: palette.info.main,
                        transition: '0s',
                    },
                    ...(isLandscapeMobile
                        ? {
                              fontSize: 20,
                              padding: '12% 4%',
                              maxHeight: 75,
                              maxWidth: 75,
                          }
                        : isMediumScreen && !isLandscapeTablet
                        ? {
                              fontSize: 28,
                              padding: '15px 30px',
                              maxHeight: 75,
                              maxWidth: 75,
                          }
                        : isMobile
                        ? {
                              padding: '30px 15px',
                              maxHeight: 40,
                              maxWidth: 40,
                          }
                        : isLandscapeTablet
                        ? {
                              padding: '30px 15px',
                              maxHeight: 50,
                              maxWidth: 50,
                          }
                        : {
                              fontSize: '46px',
                              padding: '17px 40px',
                              maxHeight: 100,
                              maxWidth: 100,
                          }),
                } as any
            }
            onMouseDown={() => onClick(number)}
        >
            {number}
        </Button>
    )
}

export default NumberButton
